// extracted by mini-css-extract-plugin
export default {"successPage":"SuccessPage_successPage__AUAYv","homeButton":"SuccessPage_homeButton__sN0gX","icon":"SuccessPage_icon__N+n4H","actionButton":"SuccessPage_actionButton__HqOsb"};